import React from "react";
import { FaCheckCircle, FaLock, FaBuilding } from "react-icons/fa";
import { FaShieldAlt, FaUserFriends, FaServer, FaDesktop, FaClipboardCheck, FaHeadphones,FaDatabase  } from 'react-icons/fa';
import { motion } from "framer-motion";
const AadhaarHeroSection = () => {

    const badgeStyle = {
  backgroundColor: '#f5f5f5',
  padding: '0.75rem 1.5rem',
  borderRadius: '999px',
  fontSize: '1rem',
  fontWeight: 500,
  color: '#000',
  boxShadow: '0 2px 6px rgba(0,0,0,0.05)',
};

const services = [
    {
      icon: <FaShieldAlt size={24} color="white" />,
      title: 'AUA/KUA Authentication',
      desc: 'Real-time Aadhaar authentication with biometric and demographic verification',
      bgColor: '#1E40AF', // Blue
    },
    {
      icon: <FaUserFriends size={24} color="white" />,
      title: 'eKYC & Biometric Authentication',
      desc: 'Streamlined customer onboarding with instant identity verification',
      bgColor: '#047857', // Green
    },
    {
      icon: <FaServer size={24} color="white" />,
      title: 'Infra & Data Center Management',
      desc: 'Enterprise-grade infrastructure with redundancy and disaster recovery',
      bgColor: '#9333EA', // Purple
    },
    {
      icon: <FaDesktop size={24} color="white" />,
      title: 'Production Environment Monitoring',
      desc: '24/7 real-time monitoring with automated alerts and response systems',
      bgColor: '#DC2626', // Red
    },
    {
      icon: <FaClipboardCheck size={24} color="white" />,
      title: 'Audit & Compliance Handling',
      desc: 'Complete audit trails and regulatory compliance management',
      bgColor: '#F59E0B', // Amber
    },
    {
      icon: <FaHeadphones size={24} color="white" />,
      title: '24/7 Technical Support',
      desc: 'Round-the-clock expert support for seamless operations',
      bgColor: '#0E7490', // Cyan
    },
  ];
 const items = [
    {
      icon: <FaShieldAlt size={24} color="white" />,
      title: 'ISO/IEC 27001',
      desc: 'Information security management system certification',
      bgColor: '#1D4ED8', // Blue
    },
    {
      icon: <FaCheckCircle size={24} color="white" />,
      title: 'UIDAI Compliance',
      desc: 'Full adherence to UIDAI guidelines and regulations',
      bgColor: '#047857', // Green
    },
    {
      icon: <FaLock size={24} color="white" />,
      title: 'End-to-End Encryption',
      desc: 'Advanced encryption protocols for data protection',
      bgColor: '#9333EA', // Purple
    },
    {
      icon: <FaDatabase size={24} color="white" />,
      title: 'Real-time Monitoring',
      desc: 'Continuous monitoring with automated threat detection',
      bgColor: '#F59E0B', // Amber
    },
  ];


  return (
    <>
    <div
      style={{
        width: "100%",
        background: "linear-gradient(to right, #e9fdf8ff, #dee1f7ff)",
        padding: "90px 20px",
        boxSizing: "border-box",
      }}
    >
      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
          padding: "0 20px",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: "40px",
        }}
      >
         <style>
        {`
          @keyframes slideInLeft {
            0% {
              transform: translateX(-50px);
              opacity: 0;
            }
            100% {
              transform: translateX(0);
              opacity: 1;
            }
          }

          @keyframes zoomIn {
            0% {
              transform: scale(0.8);
              opacity: 0;
            }
            100% {
              transform: scale(1);
              opacity: 1;
            }
          }

          .animated-left {
            animation: slideInLeft 1s ease-out forwards;
          }

          .zoom-in {
            animation: zoomIn 1s ease-out forwards;
          }
        `}
      </style>
        {/* Left Content */}
        <div style={{ flex: "1 1 500px" }}className="animated-left">
         

          <h1
            style={{
              fontSize: "40px",
              fontWeight: 700,
              color: "#111827",
              lineHeight: "1.2",
              marginBottom: "16px",
            }}
          >
            Secure, Scalable Aadhaar <br />
            Solutions for{" "}
            <span style={{ color: "#278329ff" }}>Digital India</span>
          </h1>

          <p
            style={{
              fontSize: "18px",
              color: "#374151",
              marginBottom: "32px",
              maxWidth: "600px",
              lineHeight:"2"
            }}
          >
            Empowering Governments and Enterprises with AUA/KUA<br/> Authentication &
            Infrastructure Services
          </p>

          <button
            style={{
              backgroundColor: "#278329ff",
              color: "#fff",
              fontWeight: "600",
              padding: "12px 24px",
              borderRadius: "12px",
              border: "none",
              cursor: "pointer",
            }}
          >
            Get in Touch →
          </button>
        </div>

        {/* Right Image with Zoom Animation */}
        <motion.div  className="zoom-in"
          style={{
            flex: "1 1 400px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
          initial={{ scale: 0.9 }}
          animate={{ scale: 1 }}
          transition={{ duration: 0.8, ease: "easeInOut" }}
        >
          <img
            src="/assets/images/aadhaarimage.png"
            alt="Digital India"
            style={{
              width: "100%",
              maxWidth: "500px",
              borderRadius: "12px",
              // boxShadow: "0 10px 30px rgba(0,0,0,0.1  )",
            }}
          />
        </motion.div>
      </div>
    </div>
       <section>  
        <div
      style={{
        backgroundColor: "#ffffffff", // light gray background
        padding: "40px 0px",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          display: "flex",
          gap: "60px",
          maxWidth: "1200px",
          width: "100%",
          justifyContent: "space-between",
          flexWrap: "wrap",
        }}
      >
        {/* Card 1 */}
        <div
          style={{
            flex: "1 1 300px",
            textAlign: "center",
            padding: "20px",
          }}
        >
          <div
            style={{
              width: "64px",
              height: "64px",
              borderRadius: "50%",
              backgroundColor: "#0033cc", // deep blue
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 20px",
            }}
          >
            <FaCheckCircle color="#fff" size={30} />
          </div>
          <h3 style={{ fontSize: "18px", fontWeight: "600", color: "#111827", marginBottom: "8px" }}>
            AUA/KUA Authentication Services
          </h3>
          <p style={{ color: "#6b7280", fontSize: "15px" }}>
            Certified authentication with real-time verification
          </p>
        </div>

        {/* Card 2 */}
        <div
          style={{
            flex: "1 1 300px",
            textAlign: "center",
            padding: "20px",
          }}
        >
          <div
            style={{
              width: "64px",
              height: "64px",
              borderRadius: "50%",
              backgroundColor: "#f97316", // orange
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 20px",
            }}
          >
            <FaLock color="#fff" size={28} />
          </div>
          <h3 style={{ fontSize: "18px", fontWeight: "600", color: "#111827", marginBottom: "8px" }}>
            Secure Production & Infra Maintenance
          </h3>
          <p style={{ color: "#6b7280", fontSize: "15px" }}>
            Enterprise-grade security with 24/7 monitoring
          </p>
        </div>

        {/* Card 3 */}
        <div
          style={{
            flex: "1 1 300px",
            textAlign: "center",
            padding: "20px",
          }}
        >
          <div
            style={{
              width: "64px",
              height: "64px",
              borderRadius: "50%",
              backgroundColor: "#0033cc", // deep blue
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 20px",
            }}
          >
            <FaBuilding color="#fff" size={26} />
          </div>
          <h3 style={{ fontSize: "18px", fontWeight: "600", color: "#111827", marginBottom: "8px" }}>
            Govt Projects: Telangana & Assam
          </h3>
          <p style={{ color: "#6b7280", fontSize: "15px" }}>
            Trusted partnerships with state governments
          </p>
        </div>
      </div>
    </div></section>
     <section style={{ padding: '3rem 2rem', textAlign: 'center', backgroundColor: '#fff' }}>
      <h2 style={{ fontWeight: 'bold', fontSize: '2.5rem', color: '#000' }}>
        Trusted by Governments, Powered by Innovation
      </h2>

      <p style={{ maxWidth: '900px', margin: '1rem auto', color: '#52657A', fontSize: '1.1rem' }}>
        As a certified Authentication User Agency (AUA) and Know Your Customer User Agency (KUA),
        Transaction Analysts stands at the forefront of India&apos;s digital identity infrastructure.
      </p>

      <p style={{ maxWidth: '1000px', margin: '1rem auto', color: '#52657A', fontSize: '1.1rem' }}>
        Our strategic partnerships with UIDAI and State Governments enable us to deliver seamless,
        secure, and scalable Aadhaar-based authentication services that power critical government
        and enterprise applications across the nation.
      </p>

      <p style={{ maxWidth: '1000px', margin: '1rem auto', color: '#52657A', fontSize: '1.1rem' }}>
        With cutting-edge encryption protocols, real-time authentication capabilities, and unwavering
        compliance standards, we ensure the highest levels of security and reliability for every transaction.
      </p>

      <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: '1rem', marginTop: '2rem' }}>
        <span style={badgeStyle}>UIDAI Certified</span>
        <span style={badgeStyle}>ISO 27001</span>
        <span style={badgeStyle}>99.9% Uptime</span>
        <span style={badgeStyle}>10M+ Transactions</span>
      </div>
    </section>
 <section style={{ backgroundColor: '#f6f8fb', padding: '4rem 2rem' }}>
      <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
        <h2 style={{ fontSize: '40px', fontWeight: 'bold' }}>Our Aadhaar Services</h2>
        <p style={{ fontSize: '1.1rem', color: '#52657A' }}>
          Comprehensive solutions for secure digital authentication
        </p>
      </div>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
          gap: '2rem',
          maxWidth: '1200px',
          margin: '0 auto',
        }}
      >
        {services.map((service, index) => (
          <div
            key={index}
            style={{
              background: 'white',
              borderRadius: '12px',
              padding: '2rem 1.5rem',
              boxShadow: '0 8px 20px rgba(0, 0, 0, 0.05)',
              textAlign: 'center',
            }}
          >
            <div
              style={{
                backgroundColor: service.bgColor,
                width: '50px',
                height: '50px',
                margin: '0 auto 1rem',
                borderRadius: '10px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              {service.icon}
            </div>
            <h3 style={{ fontSize: '1.2rem', fontWeight: 600 }}>{service.title}</h3>
            <p style={{ fontSize: '0.95rem', color: '#52657A', marginTop: '0.5rem' }}>{service.desc}</p>
          </div>
        ))}
      </div>
    </section>
       <section style={{ backgroundColor: '#f6f8fb', padding: '4rem 2rem' }}>
      <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
        <h2 style={{ fontSize: '2.5rem', fontWeight: 'bold' }}>Security & Compliance</h2>
        <p style={{ fontSize: '1.1rem', color: '#52657A' }}>
          Industry-leading security standards and regulatory compliance
        </p>
      </div>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '2rem',
          maxWidth: '1200px',
          margin: '0 auto',
        }}
      >
        {items.map((item, index) => (
          <div
            key={index}
            style={{
              background: 'white',
              borderRadius: '12px',
              padding: '2rem 1.5rem',
              boxShadow: '0 8px 20px rgba(0, 0, 0, 0.05)',
              textAlign: 'center',
            }}
          >
            <div
              style={{
                backgroundColor: item.bgColor,
                width: '50px',
                height: '50px',
                margin: '0 auto 1rem',
                borderRadius: '10px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              {item.icon}
            </div>
            <h3 style={{ fontSize: '1.1rem', fontWeight: 600 }}>{item.title}</h3>
            <p style={{ fontSize: '0.95rem', color: '#52657A', marginTop: '0.5rem' }}>{item.desc}</p>
          </div>
        ))}
      </div>
    </section>
    </>
  );
};

export default AadhaarHeroSection;
